module.exports = __webpack_public_path__ + "img/404.5d394041.png";